import Service from './Service'
import { USER } from './apiUrls'

export default class UserService extends Service {
  checkToken (query) {
    return this.axios.get('token', {params: query})
  }
  resetMethods (query, origin) {
    return this.axios.get('password-token', {params: query, headers: {'APPHOST': origin}})
  }
  askToken (data, origin) {
    return this.axios.post('password-token', data, {headers: {'APPHOST': origin}})
  }
  resetPassword (data, origin) {
    return this.axios.post('password-reset', data, {headers: {'APPHOST': origin}})
  }
  updatePassword (data) {
    return this.axios.put('password-update', data)
  }
  invite (data, origin) {
    return this.axios.post('user-invitation', data, {headers: {'APPHOST': origin}})
  }
  hasAccess (id, query) {
    return this.axios.get(`${USER}/${id}/has-access`, {params: query})
  }
}



// WEBPACK FOOTER //
// ./src/services/api/UserService.js